export var RequestStatus;
(function (RequestStatus) {
    RequestStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Pending group request. */
    RequestStatus["PENDING"] = "PENDING";
    /** Approved group request. */
    RequestStatus["APPROVED"] = "APPROVED";
    /** Rejected group request. */
    RequestStatus["REJECTED"] = "REJECTED";
    /** Cancelled group request. */
    RequestStatus["CANCELLED"] = "CANCELLED";
})(RequestStatus || (RequestStatus = {}));
export var ItemsToUpdate;
(function (ItemsToUpdate) {
    /** Take into account only items which are listed in request. */
    ItemsToUpdate["BY_ID"] = "BY_ID";
    /** Update all items. */
    ItemsToUpdate["ALL_ITEMS"] = "ALL_ITEMS";
})(ItemsToUpdate || (ItemsToUpdate = {}));
export var OwnershipFilter;
(function (OwnershipFilter) {
    /** All items. */
    OwnershipFilter["ALL"] = "ALL";
    /** Items for current site member. */
    OwnershipFilter["CURRENT_MEMBER"] = "CURRENT_MEMBER";
})(OwnershipFilter || (OwnershipFilter = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.js.map